// extracted by css-extract-rspack-plugin
export default {"container":"_b8820583","sectionDivider":"_9781fb0c"};